import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragDropIcon from '../../resources/icons/drag_drop.svg';

import css from './DragDropElement.css';

const DragDropElement = ({ index, value = '' }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: value,
        data: { index, value },
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isDragging ? 'var(--blue100)' : undefined,
    };

    return (
        <div ref={setNodeRef} key={value} style={style} className={css.value} {...attributes} {...listeners}>
            <DragDropIcon className={css.dragDropIcon} />
            {value}
        </div>
    );
};

DragDropElement.propTypes = {
    value: PropTypes.string,
    onDragOver: PropTypes.func,
    index: PropTypes.number,
};

export default DragDropElement;
